import { pageHead } from "@/lib/routeHead";
import { createFileRoute } from "@tanstack/react-router";
import DigitalTransformationPage from "@/pages/service/DigitalTransformationPage";

export const Route = createFileRoute("/service/digital-transformation")({
  head: () => pageHead("Digital & AI Transformation", "Enterprise-wide digital transformation and AI modernization services. From legacy system modernization to AI adoption, we guide organizations through sustainable transformation.", "/service/digital-transformation", false),
  component: DigitalTransformationPage,
});
